import { accordion } from "./_accordion";
import { card01 } from "./_card01";
import { animation } from "./_animation";
import { countUp } from "./_countUp";
import { common } from "./_common";
import { drawer } from "./_drawer";
import { header } from "./_header";
import { slide } from "./_slide";
import { modal } from "./_modal";
import { mapToggle } from "./_map";
import { test } from "./_test";
import { tab } from "./_tab";

const init = () => {
  accordion();
  card01();
  animation();
  // countUp();
  // common();
  drawer();
  header();
  slide();
  modal();
  // mapToggle(); // マップ常時表示のため一時無効（クリック展開に戻す場合は有効化）
  // test();
  // tab();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}